export default __webpack_public_path__ + "static/media/LetsTacoBoutFood.bbad7627.png";